/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._30huDKYbGa%7Bborder%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDS5Zs%7Bborder-radius%3Avar(--ds-radius-full%2C9999px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3SamIHNHnM%7Bmargin-block%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2YLqiKPgdg%7Bmargin-inline%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXruKcZT%7Bbackground-color%3Avar(--ds-background-neutral-hovered%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0V4Jdh%7Bheight%3A2px%7D");
import { ClassAttributes, HTMLAttributes } from 'react';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- jsx is required by the @jsx pragma in this file.

import styled, { StyledComponentClass } from 'styled-components';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export const Divider: StyledComponentClass<ClassAttributes<HTMLHRElement> & HTMLAttributes<HTMLHRElement> & {
  margin?: string;
}, any, ClassAttributes<HTMLHRElement> & HTMLAttributes<HTMLHRElement> & {
  margin?: string;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Existing style migration deferred; ignored via go/DSP-18766.
> = styled.hr<{
  margin?: string;
}>(({
  margin
}) => ({
  border: 'none',
  backgroundColor: "var(--ds-border, #0B120E24)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  margin: margin ? margin : '1.714em 0',
  height: '2px',
  borderRadius: "var(--ds-radius-full, 9999px)"
}));
const dividerStyles = {
  root: "_30huDKYbGa _0bjKvDS5Zs _3SamIHNHnM _2YLqiKPgdg _0KLXruKcZT _0jFU0V4Jdh"
};
type DividerCompiledProps = {
  margin?: string;
  height?: string;
};
export function DividerCompiled({
  margin,
  height
}: DividerCompiledProps): JSX.Element {
  return <hr role="presentation" style={{
    margin: margin ? margin : '1.714em 0',
    height: height ? height : '2px'
  }} className={ax([dividerStyles.root])} />;
}